import './panel.scss';
import { h } from 'preact';

export const Panel = props => {
    return (
        <section className="panel" data-grid={ `${props.grid}` } { ...props }>
            { props.children }
        </section>
    );
};